var e=typeof globalThis!=="undefined"?globalThis:typeof window!=="undefined"?window:typeof global!=="undefined"?global:typeof self!=="undefined"?self:{};export{e as commonjsGlobal};
//# sourceMappingURL=_commonjsHelpers.js.map
